import axios from 'axios';
import { sessionService } from './session';
import { getErrorMessage } from '../utils/errorMessage';

const request = axios.create({
  baseURL: "https://clinicapsiquear.com.br/api/",
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-store'
  }
});

request.interceptors.request.use((axiosConfig) => {
  const token = sessionService.getToken();

  if (token) {
    axiosConfig.headers.Authorization = `Bearer ${token}`;
  }

  return axiosConfig;
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    const userMessage = getErrorMessage(error);
    error.userMessage = userMessage;
    error.message = userMessage;

    if (error.response && error.response.status === 401) {
      sessionService.clear();
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }

    return Promise.reject(error);
  }
);

export { request };
